import {docReady} from './../../../putzmeister/src/js/components/theme/events';

function makeTargetBlank() {
    // 1. Eine Liste der Selektoren als kommagetrennte Zeichenkette definieren
    var selectors = [
        'a[href*="trouver-un-revendeur"]' // Der Händler-Link
        //'a[href$=".pdf"]',                 // Alle PDF-Links
        //'a[href*="kontaktformular"]'       // Ein Beispiel für einen anderen Link
    ].join(', '); // Fügt die Selektoren zu einer Zeichenkette zusammen, getrennt durch Komma und Leerzeichen

    // 2. Alle passenden Elemente abrufen (NodeList)
    var linkElements = document.querySelectorAll(selectors);

    // 3. Die Liste durchlaufen und die Attribute setzen
    linkElements.forEach(function(linkElement) {
        // Target setzen
        linkElement.setAttribute('target', '_blank');

        // rel="noopener" für die Sicherheit hinzufügen
        var relValue = linkElement.getAttribute('rel') || '';
        if (relValue.indexOf('noopener') === -1) {
            linkElement.setAttribute('rel', (relValue + ' noopener').trim());
        }
    });

    if (linkElements.length > 0) {
        console.log(`Target _blank erfolgreich für ${linkElements.length} Links gesetzt.`);
    } else {
        console.log('Keine der gesuchten Links gefunden.');
    }
}

docReady(() => {
    makeTargetBlank();
})
